import { useEffect } from 'react';
import { track } from './analytics';

// The funnel's denominators. Lead source already tells us which CTA produced a
// submission; these tell us how many people got far enough to see one, so a
// conversion rate has something to divide by.
//
// `contact-seen` is the important one: submissions over form-views is the only
// honest read on whether the form itself is working, as opposed to whether
// traffic is up.
const MILESTONES = [
    ['process', 'reached-process'],
    ['about', 'reached-about'],
    ['contact', 'contact-seen'],
];

function useFunnelMilestones() {
    useEffect(() => {
        if (!('IntersectionObserver' in window)) return;

        const observers = MILESTONES.map(([id, event]) => {
            const target = document.getElementById(id);
            if (!target) return null;

            const observer = new IntersectionObserver(([entry]) => {
                if (!entry.isIntersecting) return;

                track(event);
                // one per visit — scrolling back up shouldn't inflate the count
                observer.disconnect();
            }, { threshold: 0.2 });

            observer.observe(target);
            return observer;
        });

        return () => observers.forEach(observer => observer?.disconnect());
    }, []);
}

export default useFunnelMilestones;
